import { Outlet } from 'react-router-dom';
import MediaSidebar from './MediaSidebar';

export default function MediaLayout() {
  return (
    <div className="flex h-full bg-gray-50 dark:bg-gray-900">
      <MediaSidebar />
      <div className="flex-1 overflow-y-auto">
        <Outlet />
      </div>
    </div>
  );
}
